
export const PERSON_MANAGER_GET_OPERATION_LIST = 'PERSON_MANAGER_GET_OPERATION_LIST';